import { Plane } from "lucide-react";

interface Route {
  d: string;
  delay: number;
}

const ROUTES: Route[] = [
  { d: "M -50 600 Q 300 200 700 350 T 1300 200", delay: 0 },
  { d: "M -50 200 Q 400 500 900 300 T 1300 600", delay: 1.5 },
  { d: "M -50 450 Q 250 700 600 500 T 1300 400", delay: 3 },
];

const DOTS: [number, number][] = [
  [120, 600],
  [700, 350],
  [1080, 220],
  [400, 540],
  [880, 430],
];

interface RoutesSceneProps {
  accent: string;
}

export const RoutesScene = ({ accent }: RoutesSceneProps) => {
  return (
    <div className="gg-scene gg-scene-routes">
      <div
        className="gg-halo"
        style={{
          background: `radial-gradient(circle at 50% 50%, ${accent}22, transparent 60%)`,
        }}
      />
      <svg
        className="gg-routes-svg"
        viewBox="0 0 1200 800"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          {ROUTES.map((r, i) => (
            <path key={`p${i}`} id={`gg-route-${i}`} d={r.d} />
          ))}
        </defs>

        {ROUTES.map((r, i) => (
          <g key={i}>
            <path
              d={r.d}
              stroke={accent}
              strokeWidth={1.2}
              strokeDasharray="4 8"
              fill="none"
              opacity={0.45}
            />
            <g>
              <g transform="rotate(45)">
                <Plane
                  size={18}
                  color={accent}
                  fill={accent}
                  x={-9}
                  y={-9}
                  strokeWidth={2}
                />
              </g>
              <animateMotion
                dur={`${10 + i * 2}s`}
                begin={`${r.delay}s`}
                repeatCount="indefinite"
                rotate="auto"
              >
                <mpath href={`#gg-route-${i}`} />
              </animateMotion>
            </g>
          </g>
        ))}

        {DOTS.map(([x, y], i) => (
          <g key={`d${i}`}>
            <circle cx={x} cy={y} r={4} fill={accent} />
            <circle
              cx={x}
              cy={y}
              r={4}
              fill="none"
              stroke={accent}
              strokeWidth={1.5}
              opacity={0.5}
            >
              <animate
                attributeName="r"
                from={4}
                to={22}
                dur="3s"
                begin={`${i * 0.6}s`}
                repeatCount="indefinite"
              />
              <animate
                attributeName="opacity"
                from={0.6}
                to={0}
                dur="3s"
                begin={`${i * 0.6}s`}
                repeatCount="indefinite"
              />
            </circle>
          </g>
        ))}
      </svg>
    </div>
  );
};
